module.exports = "/virtual-football-league/img/amblems/left/logos/StrokeCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/StrokeCity.png
// module id = 2126
// module chunks = 4